import { IDialogConfig, DialogConfigOverride } from "../interfaces/dialog.interfaces";

export const defaultDialogConfig: IDialogConfig = {
    styles: {
        dialog: {
            "& .MuiDialog-paper": {
                borderRadius: 3,
                overflow: "hidden",
            },
        },
        paper: {
            backgroundColor: "var(--fx-surface-base, #FFFFFF)",
        },
        content: {
            p: 0,
        },
        actions: {
            display: "flex",
            justifyContent: "center",
            gap: 1.5,
            px: 3,
            pb: 3,
        },
        primaryButton: {
            backgroundColor: "var(--fx-surface-sidebar, #233044)",
            color: "#ffffff",
            "&:hover": {
                backgroundColor: "#111827",
            },
        },
        secondaryButton: {
            backgroundColor: "var(--fx-surface-muted, #F1F5F9)",
            color: "#233044",
            "&:hover": {
                backgroundColor: "#d1d5db",
            },
        },
    },
    buttons: {
        primary: {
            variant: "contained",
        },
        secondary: {
            variant: "contained",
        },
    },
};

export const createDialogConfig = (config: DialogConfigOverride = {}): IDialogConfig => ({
    styles: {
        ...defaultDialogConfig.styles,
        ...config.styles,
    },
    buttons: {
        ...defaultDialogConfig.buttons,
        ...config.buttons,
    },
});
